import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const carouselBlocks = document.querySelectorAll('.generic-carousel');

  if (0 < carouselBlocks.length) {
    carouselBlocks.forEach((carouselBlock) => {
      new Swiper(carouselBlock.querySelector('.generic-carousel__carousel'), {
        slidesPerView: 1.3,
        spaceBetween: 8,

        navigation: {
          prevEl: carouselBlock.querySelector('.generic-carousel__carousel__prev'),
          nextEl: carouselBlock.querySelector('.generic-carousel__carousel__next'),
        },

        pagination: {
          el: carouselBlock.querySelector(
            '.generic-carousel__carousel__pagination'
          ),
          type: 'fraction',
        },

        breakpoints: {
          600: {
            slidesPerView: 2.3,
            spaceBetween: 8,
          },
          1080: {
            spaceBetween: 30,
            slidesPerView: 3.45,
          },
          1440: {
            slidesPerView: 'auto',
            spaceBetween: 30,
          },
        },

        a11y: {
          firstSlideMessage: _x(
            'This is the first slide',
            'swiper label',
            'vtx'
          ),
          lastSlideMessage: _x('This is the last slide', 'swiper label', 'vtx'),
          prevSlideMessage: _x('Go to previous slide', 'swiper label', 'vtx'),
          nextSlideMessage: _x('Go to next slide', 'swiper label', 'vtx'),
          slideLabelMessage: _x(
            'Slide {{index}} of {{slidesLength}}',
            'swiper label',
            'vtx'
          ),
          paginationBulletMessage: _x(
            'Go to slide {{index}}',
            'swiper label',
            'vtx'
          ),
        },
      });
    });
  }
});
